import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { RewardVerificationModalPage } from './reward-verification-modal.page';

const routes: Routes = [
  {
    path: '',
    component: RewardVerificationModalPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class RewardVerificationModalPageRoutingModule {}
